const config = {
    mode: 'PRO', // DEV | PRO

    hostDev: 'http://localhost:8070/',
    hostPro: 'https://h05t-pposgrado.unsm.edu.pe/'
};

export const BASE_URL = config.mode === 'DEV' ? config.hostDev : config.hostPro;

export default config;
